import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('stockItemLink', 'stockItemLinks');

const customActions = {
  async LOAD_stockItemLinksByParent({ commit, rootGetters }, parentStockItemId) {
    const data = await odata.o(rootGetters)
      .get('stockItemLinks')
      .query({
        $filter: `IsDeleted eq false AND ParentStockItemId eq ${parentStockItemId}`,
        $expand: 'ChildStockItem($expand=ProcessCheckSheets)',
      });
    commit('SET_stockItemLinks', data);
    return data;
  },
};

export default { ...actions, ...customActions };
